
export const formatCurrency = ( value: string | number ) => {

    const number = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(number)) {
        throw new Error(`Valor inválido: "${value}"`);
    }

    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(number);

}